// Vendors
import {
  FeatureFlagsLendingOnboardingEnumeration,
  TimerEnumeration,
} from '@gruposantander/opbpay-ui-core-models';
// Constants
import {
  SESSION_5_MINUTES_TO_GO_IN_MS,
  SESSION_HALF_TIME_IN_MS,
  SESSION_MAX_TIME_IN_MS,
} from './constants/session-expire.handlers.utils.constants';
import { ONBOARDING_INIT_LOCAL_STORAGE } from 'constants/app.constants';
// Types
import { SessionExpireHandlersBuilderType } from '../types/session-expire.handlers.type';

const getTimeDiffFromOnboardingInit = (): number =>
  Math.abs(
    Number(new Date(sessionStorage.getItem(ONBOARDING_INIT_LOCAL_STORAGE) as string)) - Date.now()
  );

const onboardingTimeHasBeenReached = (): boolean =>
  getTimeDiffFromOnboardingInit() >= SESSION_MAX_TIME_IN_MS;

const halfOnboardingMaxTimeAchieved = (flag: boolean): boolean =>
  !flag &&
  Math.abs(getTimeDiffFromOnboardingInit() - SESSION_HALF_TIME_IN_MS) <=
    TimerEnumeration.TIMEOUT_ONE_SECOND;

const fiveMinuteToGoOnOnboarding = (flag: boolean): boolean =>
  !flag &&
  Math.abs(getTimeDiffFromOnboardingInit() - SESSION_5_MINUTES_TO_GO_IN_MS) <=
    TimerEnumeration.TIMEOUT_ONE_SECOND;

const onboardingInitDateStoredItemIsOn = (): boolean =>
  Boolean(sessionStorage.getItem(ONBOARDING_INIT_LOCAL_STORAGE));

const thereIsOnboardingInitDateAndFeatureEnabled = (
  isUsableFeature: SessionExpireHandlersBuilderType['isUsableFeature']
): boolean =>
  isUsableFeature(FeatureFlagsLendingOnboardingEnumeration.SESSION_TIMEOUT_CONTROLLER) &&
  onboardingInitDateStoredItemIsOn();

export {
  fiveMinuteToGoOnOnboarding,
  halfOnboardingMaxTimeAchieved,
  onboardingTimeHasBeenReached,
  onboardingInitDateStoredItemIsOn,
  thereIsOnboardingInitDateAndFeatureEnabled,
};
